import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import type { Category, Size } from "../../../../gobalType";
import {
  parsePlantsFromSearch,
  parseSizesFromSearch,
} from "../utils/parseFilterParams";

/** Chỉ giữ 1 phần tử (khi mở link cũ đa lựa chọn) */
function toSingleId(ids: number[]): number[] {
  if (ids.length <= 1) return ids;
  return [ids[0]];
}
function toSingleSize(values: string[]): string[] {
  if (values.length <= 1) return values;
  return [values[0]];
}

export function usePlantsFilter(categories: Category[], allSize: Size[]) {
  const location = useLocation();
  const navigate = useNavigate();

  const [arrchoicePlant, setArrchoicePlant] = useState<number[]>(() =>
    toSingleId(parsePlantsFromSearch(location.search))
  );
  const [arrchoiceSize, setArrchoiceSize] = useState<string[]>(() =>
    toSingleSize(parseSizesFromSearch(location.search))
  );

  const handleChoicePlant = useCallback((cate: Category) => {
    if (cate.id === 0) {
      setArrchoicePlant([]);
      return;
    }
    setArrchoicePlant([cate.id]);
  }, []);

  const handleChoiceSize = useCallback((size: Size) => {
    if (size.value === "all") {
      setArrchoiceSize([]);
      return;
    }
    setArrchoiceSize([size.value]);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();

    if (arrchoicePlant.length > 0) {
      params.set("plants", arrchoicePlant.join(","));
    }

    if (arrchoiceSize.length > 0) {
      params.set("sizes", arrchoiceSize.join(","));
    }

    const nextSearch = params.toString();
    const currentSearch = location.search.replace(/^\?/, "");

    if (nextSearch !== currentSearch) {
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch ? `?${nextSearch}` : "",
        },
        { replace: true }
      );
    }
  }, [
    arrchoicePlant,
    arrchoiceSize,
    location.pathname,
    location.search,
    navigate,
  ]);

  return {
    arrchoicePlant,
    arrchoiceSize,
    handleChoicePlant,
    handleChoiceSize,
  };
}
